$('.basket a').click(function(e) {

    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (w < 768){
        return;
    }

    e.preventDefault();

    updatePopover();
})


$(document).on('hidden.bs.popover', function() {
    $('body').removeClass('popover-bg');
})

$(document).on('show.bs.popover', function() {
    $('body').addClass('popover-bg');
})

$(document).on('click', '.cart-popover .close', function(e) {
    $('.basket a').popover('hide');
});

$(document).on('submit', 'form[action="/cart/add"]', function(e) {

    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (w < 768){
        return;
    }

    e.preventDefault();
    $form = $(this);

    $('#add-to-cart-error').html('');

    let $values = $(this).serializeArray();

    let index = $values.findIndex(p => p.name == "id")

    if (index < 0) {
        $('#add-to-cart-error').html('Please select an option');
        return false;
    }

    let id = $values[index].value

    if (!id) {
        $('#add-to-cart-error').html('Please select an option');
        return false;
    }

    // add to the javascript API
    $cartBtn = $('#AddToCart');
    var originalCartMessage = $cartBtn.html();

    $cartBtn.prop('disabled', true);
    $cartBtn.html('Adding...');


    $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: $values,
            dataType: "html",

        })
        .done(function(d) {
            $.get('/cart.js', function(data) {
                var itemCount = JSON.parse(data).item_count;
                $('.basket span').html(itemCount);
                $('.basket a').eq(0).trigger('click');
            })
        })
        .fail(function(error) {
            // The AJAX call failed - submit the form manually
            $form[0].submit();
        })
        .always(function() {
            $cartBtn.prop('disabled', false);
            $cartBtn.html(originalCartMessage);
        });
})

function updatePopover() {

    $this = $('.basket a');

    $this.popover('dispose');




    $.ajax({
            type: "GET",
            url: "/?section_id=cart-popup",
            cache: false
        })
        .done(function(data) {
            $this.popover({
                container: 'body',
                html: true,
                content: data,
                sanitize: false,
                offset: '0, 7',
                customClass: 'cart-popover',
                trigger: 'focus',
            });

            $this.popover('update');

            $this.popover('show');
            $this.focus();
        })

        $.ajax({
            type: "GET",
            url: "/cart.js",
            cache: false
        }).done(function(data) {
            var response = JSON.parse(data);
            $('.basket-quantity').html(response.item_count);
        })

}